import React from 'react';
import { cn } from './cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  glass?: boolean;
  interactive?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card(
  { glass, interactive, className, children, ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-2xl overflow-hidden',
        glass
          ? 'border border-light backdrop-blur-glass'
          : 'bg-bg-2 border border-light',
        interactive && 'cursor-pointer transition-all duration-250 ease-out-quint hover:-translate-y-0.5 hover:shadow-3 focus-visible:-translate-y-0.5 focus-visible:shadow-3',
        className
      )}
      style={glass ? { background: 'var(--glass-bg)' } : undefined}
      {...rest}
    >
      {children}
    </div>
  );
});
